import { Col, Input, Row, Button, message } from "antd";
import React, { useState, useCallback, useMemo  } from "react";
import { useLocation, useNavigate , Navigate } from "react-router-dom";
import axios from "axios";

import logo from "../images/artificial-intelligence.png";
import "./login.scss";
import routes from "../routes_mapper";
import appUrl from "../config/appUrl";
import { isAuthenticated } from "../utils/commonFunctions";



const LoginContainer = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  
  const { greetingUserText, logoFile } = useMemo(() => {
    let greetingUserText = "User";
    let logoFile = logo;
    return { greetingUserText, logoFile };
  }, [location?.pathname]);

  const [state, setState] = useState({
    Id: "",
    password: "",
  });
  const [error, setError] = useState({ Id: null, password: null });
  const [loading, setLoading] = useState(false);

  const hasError = useCallback(() => {
    const { Id, password } = state;
    let error = {};

    if (!Id?.trim()) {
      error.Id = "ID cannot be blank";
    }
    
    if (!password?.trim()) {
      error.password = "Password cannot be blank";
    }

    setError(error);
    return !!Object.keys(error)?.length;
  }, [state]);


  const handleSubmit = useCallback(async () => {
  console.log('api url', appUrl.LOGIN);

  if (!hasError()) {
    setLoading(true);
    setError({});
    try {
      const payload = {
        password: state.password,
        Id: state.Id
      };
      console.log('payload', payload);

      const response = await axios.post(appUrl.LOGIN, payload);
      const data = response.data;

      if (data?.access_token) {
        // Save all response data to localStorage
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("token_type", data.token_type);
        localStorage.setItem("role", data.role);
        localStorage.setItem("tenant_id", data.tenant_id);
        
        // Also keep the old "token" key for backward compatibility
        localStorage.setItem("token", data.access_token);
        messageApi.open({
          type: 'success',
          content: 'Login Successful!',
          duration: 2,
        });
        navigate(routes.ROOT);
      } else {
        messageApi.open({
          type: 'error',
          content: data?.message || "Login failed",
          duration: 5,
        });
      }
    } catch (err) {
      console.error("Login error", err);
      
      // Extract the most helpful error message
      let errorMessage = "Something went wrong";
      
      if (err.response?.data) {
        // Check for different possible error message formats
        if (err.response.data.detail) {
          errorMessage = err.response.data.detail; // FastAPI style
        } else if (err.response.data.message) {
          errorMessage = err.response.data.message; // Custom message
        } else if (err.response.data.error) {
          errorMessage = err.response.data.error; // Generic error field
        } else if (typeof err.response.data === 'string') {
          errorMessage = err.response.data; // Direct string response
        }
      } else if (err.message) {
        // Network errors or other axios errors
        if (err.code === 'ERR_NETWORK') {
          errorMessage = "Network error. Please check your connection.";
        } else if (err.code === 'ERR_BAD_REQUEST' && err.response?.status === 401) {
          errorMessage = "Invalid credentials. Please check your ID and password.";
        } else {
          errorMessage = err.message;
        }
      }
      messageApi.open({
        type: 'error',
        content: errorMessage,
        duration: 5,
      });
    } finally {
      setLoading(false);
    }
  }
}, [hasError, navigate, state]);

  const handleChange = useCallback(
    (name) => (event) => {
      let value = event?.target?.value ?? event;
      setState((prestate) => ({
        ...prestate,
        [name]: value,
      }));
      setError({});
    },
    []
  );

    if (isAuthenticated()) {
    // Redirect authenticated users away from login
    return <Navigate to={routes.ROOT} state={{ from: location }} replace />;
  }


  return (
    <div className="loginContainer">
      {contextHolder}
      <div className="logo-container pointer">
        <img
          style={{ height: 80, width: 80 }}
          src={logoFile}
          alt="AI"
          className="logo"
        />
      </div>

      <div className="container-step-1">
        <Row className="info mt20 mb20">
          Welcome! Please sign in with your account
        </Row>

        <Row className="input-container mb20">
          <label>ID</label>
          <Input
            className="fw"
            placeholder="Enter your ID"
            size="large"
            onChange={handleChange("Id")}
            onPressEnter={handleSubmit}
            value={state?.Id}
            disabled={loading}
          />
          <Row className="error">{error?.Id}</Row>
        </Row>

        <Row className="input-container mb20">
          <Col span={24}>
            <Row justify="space-between">
              <label>Password</label>
            </Row>
          </Col>
          <Input
            type="password"
            placeholder="Enter your password"
            size="large"
            onChange={handleChange("password")}
            value={state?.password}
            onPressEnter={handleSubmit}
            disabled={loading}
          />
          <Row className="error">{error?.password}</Row>
        </Row>

        <Button
          type="primary"
          block
          onClick={handleSubmit}
          loading={loading}
          size="large"
          className="signup-btn mb20"
        >
          Login
        </Button>
      </div>
    </div>
  );
};

export default LoginContainer;